var _path, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcArrowNarrowUpRed = function SvgIcArrowNarrowUpRed(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-arrow-narrow-up",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M0,0H16V16H0Z",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y2: 10.126,
    transform: "translate(8.063 2.874)",
    fill: "none",
    stroke: "#d85e62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 3,
    y1: 3,
    transform: "translate(8.078 2.902)",
    fill: "none",
    stroke: "#d85e62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    y1: 3,
    x2: 3,
    transform: "translate(5.049 2.902)",
    fill: "none",
    stroke: "#d85e62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcArrowNarrowUpRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ic-arrow-narrow-up-red.89d2873e1710643196b52e89b2a33b04.svg";